import React from 'react';
import { useTranslation } from 'react-i18next';
import Button, { ButtonType } from 'legacy/common/components/button/Button';
import Modal, { ModalType } from 'legacy/common/components/modal/Modal';
import { IoIosWarning } from 'react-icons/io';

type DeletePromoterOfferModalProps = {
  onClose: () => void;
  handleDeletePromoterOffer: () => void;
};

const DeletePromoterOfferModal: React.FC<DeletePromoterOfferModalProps> = ({
  onClose,
  handleDeletePromoterOffer
}) => {
  const { t } = useTranslation(['events']);

  return (
    <Modal
      visible
      autoHeight
      onClose={onClose}
      type={ModalType.SMALL}
      title={t('settings.promoterOffers.modals.deleteOffer.title')}
      icon={<IoIosWarning size={20} color="#8B661E" />}
    >
      <div className="flex flex-col mx-4">
        <div className="flex flex-col gap-2 mt-6 text-sm font-normal text-[#575757]">
          {t('settings.promoterOffers.modals.deleteOffer.message')}
        </div>
        <div className="flex flex-row items-center justify-center gap-2 mt-6">
          <Button type={ButtonType.Inverted} onClick={onClose}>
            {t('settings.promoterOffers.modals.deleteOffer.cancel')}
          </Button>
          <Button type={ButtonType.Primary} onClick={handleDeletePromoterOffer}>
            {t('settings.promoterOffers.modals.deleteOffer.delete')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeletePromoterOfferModal;
